import RevisionIcon from "assets/icon/RevisionIcon"
import TrashIcon from "assets/icon/TrashIcon"

export const GridDeleteButton = ({ onClick, size = 'w-4', status = '1' }) => {
    return (
        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={onClick}>
            {status === '1' ? 
                <TrashIcon className={`fill-white ${size}`} /> :
                <RevisionIcon className={`fill-white ${size}`} /> 
            }
        </button>
    )
}